import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

var InputFeedback = function InputFeedback(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("small", {
    className: className
  }, children);
};

InputFeedback.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
var InputFeedbackStyled = styled(InputFeedback).withConfig({
  displayName: "InputFeedback__InputFeedbackStyled",
  componentId: "sc-1kglod7-0"
})(["display:block;margin-top:8px;color:#C9012F;font-size:12px;"]);
export default InputFeedbackStyled;